import {
  actionTypes,
  officeRequestSuccess,
  officeRequestFailure,
  officeEntitlementRequestSuccess,
  officeEntitlementRequestFailure,
  entitlementRequestSuccess,
  entitlementRequestFailure,
  createRequestSuccess,
  createRequestFailure,
  chainEntitlementRequestFailure,
  chainEntitlementRequestSuccess,
  getPaginatedGlobalCatalogActionSuccess,
  getPaginatedGlobalCatalogActionFailure,
} from "./actions";

import {
  fetchCreateRequest,
  fetchEntitlementRequest,
  fetchOfficeEntitlementRequest,
  fetchOfficeRequest,
  fetchChainEntitlementRequest,
  getPaginatedGlobalCatalogService,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
const fetchOfficeRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_CATALOG_REQUEST),
    mergeMap(() =>
      fetchOfficeRequest().pipe(
        map((response: any) => officeRequestSuccess(response)),
        catchError((error: any) => of(officeRequestFailure(error)))
      )
    )
  );

const fetchOfficeEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_ENTITLEMENT_CATALOG_REQUEST),
    mergeMap((action: any) =>
      fetchOfficeEntitlementRequest(action.id).pipe(
        map((response: any) => officeEntitlementRequestSuccess(response)),
        catchError((error: any) => of(officeEntitlementRequestFailure(error)))
      )
    )
  );

const fetchEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ENTITLEMENT_CATALOG_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementRequest(action.obj).pipe(
        map((response: any) => entitlementRequestSuccess(response)),
        catchError((error: any) => of(entitlementRequestFailure(error)))
      )
    )
  );

const fetchCreateRequestCatalogEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_CATALOG_REQUEST),
    mergeMap((action: any) =>
      fetchCreateRequest(action.payload).pipe(
        map((response: any) => createRequestSuccess(response)),
        catchError((error: any) => of(createRequestFailure(error)))
      )
    )
  );

const fetchChainEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CHAIN_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchChainEntitlementRequest(action.payload).pipe(
        map((response: any) => chainEntitlementRequestSuccess(response)),
        catchError((error: any) => of(chainEntitlementRequestFailure(error)))
      )
    )
  );

const fetchGlobalCatalogEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GLOBAL_CATALOG_REQUEST),
    mergeMap((action: any) =>
      getPaginatedGlobalCatalogService(action.payload).pipe(
        map((response: any) =>
          getPaginatedGlobalCatalogActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getPaginatedGlobalCatalogActionFailure(error))
        )
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  fetchOfficeRequestsEpic,
  fetchOfficeEntitlementRequestEpic,
  fetchEntitlementRequestEpic,
  fetchCreateRequestCatalogEpic,
  fetchChainEntitlementRequestEpic,
  fetchGlobalCatalogEpic,
];
